(function () {
    'use strict';

    angular
        .module('uwAgenda.settings.administration')
        .factory('Licence', LicenceFn);


    /* licence object */
    LicenceFn.$inject = ['$localStorage'];

    function LicenceFn($localStorage) {
        var Licence = function () {

            // default attribues 
            this.caption = null;

            // file-path to licence-image on server
            this.userImageTempFile = null;
           
            /* extend current object */
            this.extend = function (licence) {
                var self = this;
                angular.extend(self, licence);
            }; // this
        };

        return Licence;
    }
})();